import React from "react";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import "./SupportPage.css";

const SupportPage = () => {
    return (
        <div className="container-page">
            <PageTitle title="Central de Atendimento" />
            <div className="padding-default">
                <p className="text-justify">
                    A <strong>SANTILLANA</strong> oferece uma Central de Atendimento para receber todas as comunicações do Usuário. 
                    A Central de Atendimento está disponível por meio dos seguintes canais de comunicação:
                </p>

                <h3 className="title-medium margin-top-default">📧 E-mail</h3>
                <p className="text-justify">
                    Você pode entrar em contato pelo e-mail <strong>contatocentral@santillana.com</strong>, sempre acompanhado das informações de contato do Cliente para que possamos finalizar o atendimento.
                </p>

                <h3 className="title-medium margin-top-default">📞 Telefone</h3>
                <p className="text-justify">
                    Disponibilizamos o telefone <strong>0800 770 3004</strong> para atendimento em horário comercial, de segunda a sexta-feira.
                </p>

                <h3 className="title-medium margin-top-default">🕒 Horário de Funcionamento</h3>
                <p className="text-justify">
                    Nossa Central de Atendimento funciona de <strong>Segunda a Sexta-feira</strong>, dentro do horário comercial.
                </p>
            </div>
        </div>
    );
};

export default SupportPage;